import React from 'react';
import {
  View, StyleSheet, Platform, Image,
} from 'react-native';
import { Text, useTheme } from 'react-native-paper';

let MedalFirstPlace;
let MedalSecondPlace;
let MedalThirdPlace;

if (Platform.OS === 'web') {
  MedalFirstPlace = require('../../assets/medal-first-place-stroke-rounded.svg');
  MedalSecondPlace = require('../../assets/medal-second-place-stroke-rounded.svg');
  MedalThirdPlace = require('../../assets/medal-third-place-stroke-rounded.svg');
} else {
  MedalFirstPlace = require('../../assets/medal-first-place-stroke-rounded.svg').default;
  MedalSecondPlace = require('../../assets/medal-second-place-stroke-rounded.svg').default;
  MedalThirdPlace = require('../../assets/medal-third-place-stroke-rounded.svg').default;
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    marginBottom: 20,
    marginTop: 10,
  },
  medalContainer: {
    alignItems: 'center',
  },
  medalLabel: {
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 5,
  },
  medalCount: {
    fontSize: 20,
    fontWeight: 'bold',
  },
});

function MedalDisplay({
  icon: Icon, count, label, color, size = 40,
}) {
  const theme = useTheme();
  return (
    <View style={styles.medalContainer}>
      {Platform.OS === 'web' ? (
        <Image source={Icon} style={{ width: size, height: size, tintColor: color }} />
      ) : (
        <Icon width={size} height={size} fill={color} />
      )}
      <Text style={[styles.medalLabel, { color: theme.colors.onSurface }]}>{label}</Text>
      <Text style={[styles.medalCount, { color: theme.colors.primary }]}>{count}</Text>
    </View>
  );
}

function MedalStats({ gold, silver, bronze }) {
  return (
    <View style={styles.container}>
      <MedalDisplay icon={MedalFirstPlace} count={gold} color="#edcb0f" size={50} />
      <MedalDisplay icon={MedalSecondPlace} count={silver} color="#c0c0c0" />
      <MedalDisplay icon={MedalThirdPlace} count={bronze} color="#ce8946" />
    </View>
  );
}

export default MedalStats;
